import React from "react";

import AddIcon from "@mui/icons-material/Add";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import styles from "./TextWithPlusButton.module.css";

interface Props {
  text: string;
  onClick: () => void;
  iconInFrontOfText?: boolean;
}

const TextWithPlusButton: React.FC<Props> = ({
  text,
  onClick,
  iconInFrontOfText,
}: Props) => {
  return (
    <div className={styles.hoverArea} onClick={onClick}>
      {iconInFrontOfText && (
        <AddIcon className={toClassName(styles.icon, styles.iconBefore)} />
      )}

      <div className={styles.boldText}>{text}</div>

      {!iconInFrontOfText && (
        <AddIcon className={toClassName(styles.icon, styles.iconAfter)} />
      )}
    </div>
  );
};

export default TextWithPlusButton;
